import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '📘',
    title: 'Módulo 1 — Mecánica de Emergencia en 3 Minutos',
    desc: 'Diagnóstico rápido, lectura de ruidos y olores, protocolo de emergencia antes de llamar a la grúa.'
  }, {
    icon: '📗',
    title: 'Módulo 2 — Blindaje Mecánico Preventivo',
    desc: 'Mantenimiento casero, cambios que podés hacer vos, calendar de service sin sorpresas.'
  }, {
    icon: '📙',
    title: 'Módulo 3 — Escudo Legal y Ruta 2026',
    desc: 'Qué decir en controles de tránsito, cómo defenderte de multas, tus derechos en cada parada policial.'
  }, {
    icon: '📕',
    title: 'Módulo 4 — VTV Sin Sorpresas',
    desc: 'Checklist de pre-inspección completo, qué revisar antes de entrar, cómo aprobar sin gastar de más.'
  }, {
    icon: '📓',
    title: 'Módulo 5 — Compra Inteligente de Repuestos',
    desc: 'Dónde comprar, qué marcas elegir, cómo no pagar el triple por piezas que conseguís más baratas.'
  }, {
    icon: '📔',
    title: 'Módulo 6 — Kit Dueño Profesional',
    desc: 'Checklists completos, registro histórico de mantenimiento y ficha técnica de tu auto.'
  }];
  const includes = ['Guías listas para usar', 'Checklists de revisión imprimibles', 'Errores típicos del conductor argentino', 'Solucionario técnico completo'];
  return <section className="py-24 bg-surface border-y border-white/5" aria-label="Módulos incluidos en el pack" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <FadeIn data-id="element-152">
          <div className="text-center mb-16" data-id="element-153">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-154">
              🏆 MEGA PACK AUTO BLINDADO™
            </h2>
            <p className="text-xl text-cyan font-medium" data-id="element-155">
              6 Módulos + 5 Bonos — Todo resuelto.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-156">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-157">
              <div className="bg-background p-8 rounded-2xl border border-white/10 hover:border-cyan/50 transition-colors group h-full" data-id="element-158">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-159">
                  {mod.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-160">
                  {mod.title}
                </h3>
                <p className="text-gray-400" data-id="element-161">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-162">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-163">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-164">
              Cada módulo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-165">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-166">
                  <CheckCircle2 className="w-5 h-5 text-cyan shrink-0" data-id="element-167" />
                  <span className="text-gray-200" data-id="element-168">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}